import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";

Vue.config.productionTip = false;

import wysiwyg from "vue-wysiwyg";
import VueBreadcrumbs from "vue2-breadcrumbs";
import VueResource from "vue-resource";
import Notifications from "vue-notification";
import Nprogress from "nprogress";
import VueI18n from "vue-i18n";
import VuetifyConfirm from "vuetify-confirm";
import fullscreen from 'vue-fullscreen'
import MultiFiltersPlugin from './plugins/MultiFilters' // <-- THIS

import VeeValidate, {
  Validator
} from "vee-validate";


// global components
import GlobalComponents from "./globalComponents";

// router
import router from "./router";

// store
import {
  store
} from "./store";
/* 
import {
  storeSession
} from "../src/store"; */
// include script file
import "./imports/importVuelyScript";

// include all css files
import "./imports/importVuelyCss";

// messages
import messages from "./config/lang";

//axios
import axios from "axios";
import AppConfig from "@/config/AppConfig";

axios.defaults.baseURL = AppConfig.baseUrl;
//axios.defaults.maxContentLength = 20480000;

axios.interceptors.request.use(config => {

  const token = localStorage.getItem('accessToken')
  if (token) {
    config.headers.Authorization = "Bearer " + token
  }
  const url = config.url.split('/');

  if (url[url.length - 1] === 'login') {
    delete config.headers.Authorization;
  }

  return config;


}, error => {
  Promise.reject(error)
})
let isRefreshing = false;

let requestQueue = [];

axios.interceptors.response.use(responseRequest => {

  const status = responseRequest.data.error;

  const originalRequest = responseRequest.config;

  if (status == 104 || (status == 401 && responseRequest.data.msg == "Invalid token: access token has expired")) {
    if (!isRefreshing) {
      isRefreshing = true;
      let credentialsUser = {
        grant_type: "refresh_token",
        refresh_token: localStorage.getItem("refreshToken"),
        client_id: "5c33d309cc761c4d05397c6d",
        client_secret: "65051e36023fa92764bcf351b3cb685d82e0daf802e77cff0fe493698313e1ee",
      }

      store
        .dispatch("generateToken", credentialsUser)
        .then(res => {
          if (res.data.code == 200) {
            const data = res.data.data;
            isRefreshing = false;
            onRrefreshed(data.accessToken)
            
            localStorage.setItem("accessToken", data.accessToken);
            
            let expirationTime = new Date(data.accessTokenExpiresAt);
            let expirationRefreshTime = new Date(res.data.data.refreshTokenExpiresAt);
            localStorage.setItem("expirationRefreshTime", expirationRefreshTime.getTime())

            localStorage.setItem("expirationTime", expirationTime.getTime())
            localStorage.setItem("refreshToken", data.refreshToken);
            
            requestQueue = [];
          } else {
            localStorage.clear()
            store.dispatch("logoutUser");
            router.push('/session/login');
            location.reload();
          }

        })
    }
    const requestQueues = new Promise(resolve => {
      requestTokenRefresh(token => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return resolve(axios(originalRequest));
      });
    });
    return requestQueues;
  }
  return responseRequest

})

function requestTokenRefresh(cb) {
  requestQueue.push(cb);

}

function onRrefreshed(token) { 
  requestQueue.map(cb => cb(token));
}














Nprogress.configure({
  showSpinner: false
});
// navigation guards before each
router.beforeEach((to, from, next) => {   
  if (to.matched.some(record => record.meta.requiresAuth)) {        
    if (localStorage.getItem("accessToken")) {
      store.dispatch('doSetUserProfile').then(()=>{        
        if(to.meta.scope){          
          const scopesRequired = to.meta.scope;
          if(!store.getters.userProfile){
           localStorage.clear();
            next({
              path: '/session/login',
              query: {
                redirect: "/"
              }
          });
          }
          else{          
            let scopesUser = store.getters.userScopes;     
            const valid = scopesRequired.filter(v=>scopesUser.indexOf(v)>=0)                                                   
            if(valid&&valid.length>0){
                next();
            }else{
              localStorage.clear();
              next({
                path: '/session/login',
                query: {
                  redirect: "/"
                }
            })
            }
          }
        }else{        
          next();
        }     
      })
    } else {    
      localStorage.clear();
      next({
        path: '/session/login',
        query: {
            redirect: "/"
        }
    })
    }
} else {
    next();
}
});

// navigation guard after each
router.afterEach(() => {
  Nprogress.done();
});

// Translation provided by Vuetify (typescript)
import en from 'vuetify/lib/locale/en';
// Your own translation file
import customEsVuetify from '@/config/lang/es/vuetify'

// plugins
Vue.use(MultiFiltersPlugin);
Vue.use(Vuetify, {
  iconfont: "md", // 'md' || 'mdi' || 'fa' || 'fa4'
  theme: {
    primary: "#005CAE",
    secondary: "#424242",
    accent: "#00AEEF",
    error: "#FF3739",
    info: "#00D0BD",
    success: "#00D014",
    warning: "#FFB70F",
    light_caption: "#BDBDBD",
    light_icon: "#E0E0E0",
    dark_caption: "#757575",
    dark_title: "#1A237E"
  },
  lang: {
    locales: {
      en,
      es: customEsVuetify
    },
    current: 'es'
  }
});

Vue.use(VuetifyConfirm, {
  buttonTrueText: "OK",
  buttonFalseText: "NO",
  color: "warning",
  icon: "warning",
  title: "Warning",
  width: 300,
  property: "$confirm"
});

Vue.use(VueI18n);
Vue.use(VueResource);
Vue.use(wysiwyg, {});
Vue.use(VueBreadcrumbs);
Vue.use(Notifications);
Vue.use(GlobalComponents);
Vue.use(fullscreen);
Vue.use(require('vue-moment'));

import moment from 'moment';

Vue.prototype.moment = moment;

import messageEs from '@/config/lang/es/validationMessages';
import attributesEs from '@/config/lang/es/index';
import {
  messages as esOriginalMessages
} from 'vee-validate/dist/locale/es'

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "es", // set locale
  messages, // set locale messages,
  silentTranslationWarn: false
});
export {
  i18n
};


Vue.use(VeeValidate, {
  //inject: false,
  /* i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n, */
  locale: 'es',
  dictionary: {
    es: {
      //messages: messageEs,//esOriginalMessages
      messages: {
        ...esOriginalMessages,
        ...messageEs
      },
      attributes: attributesEs
    }
  }
});

//Override default message

const rulesPlugin = ({
  Validator
}) => {
  Validator.localize('es', messageEs);
};
VeeValidate.use(rulesPlugin);

// custom validator
import StartValidator from '@/common/validator/StartValidator';
import EndValidator from '@/common/validator/EndValidator';
import TelephoneValidator from '@/common/validator/TelephoneValidator';
import NoAsurEmail from '@/common/validator/NoAsurEmail';
import TextAndNumberValidator from '@/common/validator/TextAndNumberValidator';

Validator.extend('start', StartValidator);
Validator.extend('end', EndValidator);
Validator.extend('telephone', TelephoneValidator);
Validator.extend('noAsurEmail', NoAsurEmail);
Validator.extend('textAndNumber', TextAndNumberValidator);

Vue.filter('currency', (value) => {
  value = value == null ? 0 : value;
  return '$ ' + parseFloat(value).toFixed(2);
});

const GlobalState = new Vue({
  data: {
    // aquí defines tu variable global
    validaSucursal: undefined // será true o false según necesites
  }
});

// Exponer en prototype -> accesible desde cualquier componente
Vue.prototype.$global = GlobalState.$data;
export const globalData = GlobalState.$data;
export default new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");